export default "__VITE_ASSET__CdRCUlBk__"